"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    width: palette.gutter * 45 + 'px',
    paddingTop: palette.gutter * 10 + 'px',
    paddingBottom: palette.gutter * 4 + 'px',
    paddingLeft: palette.gutter * 4 + 'px',
    paddingRight: palette.gutter * 4 + 'px',
    marginTop: 0,
    marginBottom: palette.gutter * 3 + 'px',
    marginLeft: 'auto',
    marginRight: 'auto'
  };
}